import React from 'react';
import { SvgIcon } from '../../../ThirdParty';

function Uptime(props) {
  return (
    <SvgIcon
      {...props}
      width="58"
      height="58"
      viewBox="10 17 35 25"
      fill="none"
    >
      <svg
        id="Layer_2"
        data-name="Layer 2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 187.41 151"
      >
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            d="M152.45,68.05l-5.69-.52c-1.02-.09-1.87-.81-2.17-1.79-.66-2.18-1.53-4.27-2.59-6.25-.48-.89-.39-1.98.26-2.76l3.67-4.41c.82-.99.76-2.45-.15-3.36l-7.03-7.03c-.91-.91-2.37-.98-3.36-.15l-4.41,3.67c-.78.65-1.87.74-2.76.26-1.97-1.06-4.06-1.94-6.25-2.59-.98-.3-1.7-1.14-1.79-2.17l-.52-5.69c-.12-1.28-1.19-2.27-2.48-2.27h-9.93c-1.29,0-2.37.98-2.48,2.27l-.52,5.69c-.09,1.02-.81,1.87-1.79,2.17-2.18.66-4.27,1.53-6.25,2.59-.89.48-1.98.39-2.76-.26l-4.41-3.67c-.99-.82-2.45-.76-3.36.15l-7.03,7.03c-.91.91-.98,2.37-.15,3.36l3.67,4.41c.65.78.74,1.87.26,2.76-1.06,1.97-1.94,4.06-2.59,6.25-.3.98-1.14,1.7-2.17,1.79l-5.69.52c-1.28.12-2.27,1.19-2.27,2.48v9.93c0,1.29.98,2.37,2.27,2.48l5.69.52c1.02.09,1.87.81,2.17,1.79.82,2.73,1.98,5.31,3.42,7.7.07.11.14.23.21.34.45.73,1.49.81,2.04.15l9.77-11.55c.26-.31.35-.73.24-1.11-.45-1.52-.69-3.13-.69-4.8,0-8.68,6.54-15.83,14.96-16.79.36-.04.58.38.35.65l-6.76,8.17c-.52.62-.72,1.44-.56,2.23l2.27,10.86c.24,1.12,1.15,1.96,2.28,2.09l10.46,1.25c.81.1,1.62-.18,2.19-.76l7.93-7.97c.25-.25.68-.08.68.28,0,0,0,0,0,0,0,9.34-7.57,16.9-16.9,16.9-1.6,0-3.15-.22-4.61-.64-.45-.13-.93.02-1.23.38l-9.37,11.08c-.53.63-.33,1.58.4,1.95,1.77.9,3.64,1.65,5.58,2.23.97.29,1.65,1.15,1.74,2.15l.52,5.69c.12,1.28,1.19,2.27,2.48,2.27h9.93c1.29,0,2.37-.98,2.48-2.27l.52-5.69c.09-1.02.81-1.87,1.79-2.17,2.18-.66,4.27-1.53,6.25-2.59.89-.48,1.98-.39,2.76.26l4.41,3.67c.99.82,2.45.76,3.36-.15l7.03-7.03c.91-.91.98-2.37.15-3.36l-3.67-4.41c-.65-.78-.74-1.87-.26-2.76,1.06-1.97,1.94-4.06,2.59-6.25.3-.98,1.14-1.7,2.17-1.79l5.69-.52c1.28-.12,2.27-1.19,2.27-2.48v-9.93c0-1.29-.98-2.37-2.27-2.48Z"
            fill="#152c73"
          />
          <path
            fill="#152c73"
            d="M111.91,0c-16.51,0-31.78,5.32-44.21,14.31,2.88,3.24,5.26,6.93,7.05,10.94,10.39-7.69,23.24-12.25,37.16-12.25,34.52,0,62.5,27.98,62.5,62.5s-27.98,62.5-62.5,62.5c-32.1,0-58.53-24.2-62.08-55.34-4.03,1.4-8.33,2.2-12.81,2.32,4.66,37.22,36.4,66.03,74.89,66.03,41.7,0,75.5-33.8,75.5-75.5S153.61,0,111.91,0Z"
          />
          <path
            d="M35.91,6.52C16.08,6.52,0,22.6,0,42.43s16.08,35.91,35.91,35.91,35.91-16.08,35.91-35.91S55.74,6.52,35.91,6.52Z"
            fill="#152c73"
          />
          <path
            d="M35.9,24.48c-.33,0-.65.14-.86.39l-14.55,16.9c-.29.33-.35.8-.17,1.19.18.4.58.65,1.01.66h6.71v15.64h0c0,.3.12.59.33.8.21.21.5.33.8.33h13.44c.3,0,.59-.12.8-.33.21-.21.33-.5.33-.8v-15.64h6.73s0-.01,0-.01c.44,0,.85-.25,1.03-.65.19-.4.12-.87-.17-1.21l-14.59-16.88c-.21-.25-.52-.39-.84-.39h0Z"
            fill="#FFFFFF"
          />
        </g>
      </svg>
    </SvgIcon>
  );
}
Uptime.displayName = 'Uptime';
Uptime.muiName = 'SvgIcon';

export default Uptime;
